import {
  apiDelete,
  apiFormPost,
  apiGet,
  apiPatch,
  type ApiResponse,
} from "./genesisApi/httpsMethods";
import type {
  DealHeroImageResponse,
  DealImage,
  DealImagesResponse,
} from "../types/dealImages";

export function buildDealImagesUrl(dealId: number): string {
  return `deal/${dealId}/images`;
}

export function buildDealHeroImageUrl(dealId: number): string {
  return `deal/${dealId}/hero-image`;
}

export function buildDealImageDeleteUrl(
  dealId: number,
  imageId: number,
): string {
  return `deal/${dealId}/images/${imageId}`;
}

export async function getDealImages(
  dealId: number,
): Promise<ApiResponse<DealImagesResponse>> {
  return apiGet<DealImagesResponse>(buildDealImagesUrl(dealId));
}

export async function getDealHeroImage(
  dealId: number,
): Promise<ApiResponse<DealHeroImageResponse>> {
  return apiGet<DealHeroImageResponse>(buildDealHeroImageUrl(dealId));
}

export async function uploadDealImage(
  dealId: number,
  file: File,
  options: { caption?: string; is_hero?: boolean } = {},
): Promise<ApiResponse<DealImage>> {
  const formData = new FormData();
  formData.append("file", file);
  if (options.caption) {
    formData.append("caption", options.caption);
  }
  formData.append("is_hero", String(options.is_hero ?? false));
  return apiFormPost<DealImage>(buildDealImagesUrl(dealId), formData);
}

export async function updateDealImage(
  dealId: number,
  imageId: number,
  payload: { is_hero?: boolean; caption?: string },
): Promise<ApiResponse<DealImage>> {
  return apiPatch<DealImage>(buildDealImageDeleteUrl(dealId, imageId), payload);
}

export async function deleteDealImage(
  dealId: number,
  imageId: number,
): Promise<ApiResponse<{ message: string }>> {
  return apiDelete<{ message: string }>(
    buildDealImagesUrl(dealId),
    imageId,
  );
}
